const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import getCanonincals from '../../utils/getCanonicals';
import getLocaleLink from '../../utils/getLocaleLink';
import getSocials from '../../utils/getSocials';
import type { Locale } from '../../i18n/language';

// eslint-disable-next-line import-x/prefer-default-export
export const Route = createFileRoute('/{-$locale}/')({
  head: ({
    params
  }) => {
    const locale = (params.locale ?? 'nl') as Locale;
    const title = locale === 'nl' ? 'Hofman-Consulting | Web & API design' : 'Hofman-Consulting | Web & API design';
    const description = locale === 'nl' ? `Professioneel web en API design voor moderne bedrijven.
      Wij ontwerpen en ontwikkelen gebruiksvriendelijke websites en snelle, robuuste API's.` : `Professional web and API design for modern businesses.
      We design and develop user-friendly websites and fast, robust APIs.`;
    return {
      meta: [...getSocials({
        title,
        description,
        locale
      })],
      links: [...getCanonincals({
        locale
      })],
      scripts: [{
        type: 'application/ld+json',
        children: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Hofman-Consulting',
          url: getLocaleLink({
            locale
          }),
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            email: 'support@hofman-consulting.nl',
            areaServed: 'NL'
          }
        })
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});